import { render } from "./EmployeeIndex.vue?vue&type=template&id=20455532&scoped=true"
import script from "./EmployeeIndex.vue?vue&type=script&lang=js"
export * from "./EmployeeIndex.vue?vue&type=script&lang=js"

import "./EmployeeIndex.vue?vue&type=style&index=0&id=20455532&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20455532"]])

export default __exports__